// src/redux/userSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getUserName } from "../utils/utils";
import { AnyAction, Dispatch } from "redux";
import { appendAlert } from "../redux/alertSlice";
import { PfmUser } from "../models/PfmUser";

import apiAxios from "../utils/apiAxios";

export type LANGUAGE = "ja" | "en" | "vi" | "zh" | "id";
export type USER_TYPE = "congito" | "google";

type User = {
  isLogged: boolean;
  language: LANGUAGE;
  userType: string | null;
  userInfo: PfmUser;
};

const initialState: User = {
  isLogged: !!localStorage.getItem("isLogged"),
  language: "ja",
  userType: localStorage.getItem("userType"),
  userInfo: {
    user_id: "",
    user_name: "",
    user_type: "internal",
    permissions: [],
    plant_code: "",
    proc_code: "",
    mach_code: "",
    profile_photo_url: "",
    member_id: "",
  },
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    login: (state: User) => {
      state.isLogged = true;
      localStorage.setItem("isLogged", "true");
    },
    logout: (state: User) => {
      state.isLogged = false;
      localStorage.removeItem("isLogged");
    },
    setLanguage: (state: User, action: PayloadAction<LANGUAGE>) => {
      state.language = action.payload;
    },
    setUserType: (state: User, action: PayloadAction<USER_TYPE>) => {
      state.userType = action.payload;
      localStorage.setItem("userType", state.userType);
    },
    setUserInfo(state: User, action: PayloadAction<PfmUser>) {
      state.userInfo = action.payload;
    },
  },
});
const { login, logout, setLanguage, setUserType, setUserInfo } =
  userSlice.actions;

const feathUserInfo = () => {
  return async (dispatch: Dispatch<AnyAction>) => {
    try {
      const tokenUserName = (await getUserName().then()).toString().replace("google_", "");
      const users = await apiAxios.get<PfmUser>(
        "/pfm_users/" + encodeURIComponent(tokenUserName)
      );
      if (users.data.user_id) {
        dispatch(setUserInfo(users.data));
      } else {
        dispatch(
          setUserInfo({
            user_id: tokenUserName,
            user_name: tokenUserName,
          } as PfmUser)
        );
      }
    } catch (error: any) {
      console.error(error);
      dispatch(
        appendAlert({
          severity: "error",
          message: "データの取得に失敗しました。" + error.message,
          displayTime: 5000,
        })
      );
    }
  };
};

export { login, logout, setLanguage, setUserType, feathUserInfo };
export default userSlice.reducer;
